import { NativConfig } from '../types/ConfigTypes';

export const getNativConfig = (): NativConfig | undefined => {
  const globalConfig = window.ConfigUtility;

  if (!globalConfig) {
    console.warn('Unable to load nativ config.');
    return;
  }

  const getNativPapi = (): string => {
    if (document.domain?.includes('.nativ.co')) {
      if (globalConfig.env !== 'prod') {
        return globalConfig.nativApiServer;
      }
      return 'https://api.classic.nativ.co/nativ-product-api';
    }

    return globalConfig.nativPapi.uri;
  };

  const getNativDapi = (): string => {
    if (document.domain?.includes('.nativ.co')) {
      if (globalConfig.env !== 'prod') {
        return globalConfig.nativDataApiServer;
      }
      return 'https://api.classic.nativ.co/nativ-data-api';
    }

    return globalConfig.nativDapi.uri;
  };

  return {
    agGridLicenseKey: globalConfig.agGridLicenseKey,
    apiServer: getNativPapi(), // for legacy dns
    nativPapi: {
      uri: globalConfig.nativPapi?.uri,
    },
    dataApiServer: getNativDapi(), // for legacy dns
    nativDapi: {
      uri: globalConfig.nativDapi?.uri,
    },
    dealPapi: {
      uri: globalConfig.dealPapi?.uri,
    },
    env: globalConfig.env,
    googleMapsApiKey: globalConfig.nativGoogleMapsApiKey,
    googleTagManagerContainerId: globalConfig.nativGoogleTagManagerContainerId,
    launchDarklyClientId: globalConfig.nativLaunchDarklyClientId,
    logoutURL: globalConfig.logoutURL,
    monitoring: {
      applicationId: globalConfig.monitoring?.applicationId,
      clientToken: globalConfig.monitoring?.clientToken,
    },
    sentryDsn: globalConfig.nativSentryDsn,
    singleSignOnDomain: globalConfig.nativSingleSignOnDomain,
    cognito: {
      isEnabled: globalConfig.cognito.isEnabled,
      isMocked: false,
      userPoolId: globalConfig.cognito.userPoolId,
      userPoolWebClientId: globalConfig.cognito.claUserPoolWebClientId,
      region: globalConfig.cognito.region,
    },
    cookies: {
      expires: '',
      path: globalConfig.cookies.path,
      domain: globalConfig.cookies.domain,
      secure: true,
    },
  };
};
